import request from '@host-panel/request';

export function getSSOAccountType(spotId: string) {
  return request(`/host-panel/config/${spotId}`, {
    method: 'POST',
    data: {
      fields: ['tenant.sso.account_type']
    }
  });
}
